// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReserveButton__reserveButton___oXJIS{padding:.5rem}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/reservations/concierge/ReserveButton.scss"],"names":[],"mappings":"AAAA,sCACE,aAAA","sourcesContent":[".reserveButton {\n  padding: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reserveButton": "ReserveButton__reserveButton___oXJIS"
};
export default ___CSS_LOADER_EXPORT___;
